import { StringInterface } from "./string.d";

const first = (str: string, number: number): string => {
    if (str.length <= number) {
        return str;
    } else {
        return str.substring(0, number) + "...";
    }
};

/** 是否为合法的 http/https URL（含有效 host） */
const isHttpUrl = (value: string): boolean => {
    const trimmed = value.trim();
    if (!trimmed) {
        return false;
    }
    try {
        const url = new URL(trimmed);
        return (url.protocol === "http:" || url.protocol === "https:") && Boolean(url.hostname);
    } catch {
        return false;
    }
};

export default <StringInterface>{
    first,
    isHttpUrl,
};
